import { render, staticRenderFns } from "./lianxi.vue?vue&type=template&id=51754c36&scoped=true&"
import script from "./lianxi.vue?vue&type=script&lang=js&"
export * from "./lianxi.vue?vue&type=script&lang=js&"
import style0 from "./lianxi.vue?vue&type=style&index=0&id=51754c36&scoped=true&lang=css&"
import style1 from "./lianxi.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51754c36",
  null
  
)

export default component.exports